import { CardOverlay } from './widgets/CardOverlay';
import { PlayerWidget } from './widgets/PlayerWidget';
import { SidePlayersWidget } from './widgets/SidePlayersWidget';
import { RoundTimer } from './widgets/RoundTimer';
import { StreamView } from './widgets/StreamView';
import { OverlayLanding } from './widgets/OverlayLanding';
import { DeckCompareOverlay } from './widgets/DeckCompareOverlay';
import { DeckProfileOverlay } from './widgets/DeckProfileOverlay';

export default function App() {
  const path = window.location.pathname;

  if (path.startsWith('/overlay/card')) return <CardOverlay />;
  // NOTE: /overlay/side-players must be matched before the CardOverlay fallback below —
  // route ordering is load-bearing; placing it after the fallback means it never matches.
  if (path.startsWith('/overlay/side-players')) return <SidePlayersWidget />;
  if (path.startsWith('/overlay/players')) return <PlayerWidget />;
  if (path.startsWith('/overlay/timer')) return <RoundTimer />;
  if (path.startsWith('/overlay/stream-view')) return <StreamView />;
  if (path.startsWith('/overlay/compare')) return <DeckCompareOverlay />;
  // /overlay/profile catches both /overlay/profile/p1 and /overlay/profile/p2 — slot resolved internally.
  if (path.startsWith('/overlay/profile')) return <DeckProfileOverlay />;

  // Root path: show branded overlay setup screen (not a widget)
  if (path === '/' || path === '') return <OverlayLanding />;

  // Fallback: card overlay (backward compatible for existing OBS sources)
  return <CardOverlay />;
}
